import React, { useState } from 'react';
import { Col } from 'react-bootstrap';
import { navigationConfig } from './navigationConfig';
import { useNavigate } from 'react-router-dom';
import { TabKey } from '../../constants/common';
import { useAppDispatch } from '../../store/store';
import {
    SetActiveTab,
    SetIsEditorInFullMode,
    SetIsEditorOpen,
    SetIsSidebarOpen,
} from '../../store/slice/common.slice';

interface SidebarProps {
    navigateDashboard: (page: string, element: HTMLElement) => void;
    activePage: string;
    iframeHeight: any;
}

const Sidebar: React.FC<SidebarProps> = ({ navigateDashboard, activePage, iframeHeight }) => {
    const dispatch = useAppDispatch();
    const [openDropdown, setOpenDropdown] = useState<string | null>(null);
    const navigate = useNavigate();
    const toggleDropdown = (key: string) => {
        setOpenDropdown((prev) => (prev === key ? null : key));
    };

    const renderNavItems = (items: any[]) => {
        return items.map((item, index) => (
            <React.Fragment key={item.page || index}>
                <li
                    className={`section-item d-flex justify-content-between align-items-center ${
                        activePage === item.page ? 'active' : ''
                    }`}
                    onClick={(e) =>
                        item.hasDropdown
                            ? toggleDropdown(item.page)
                            : navigateDashboard(item.page, e.currentTarget)
                    }
                >
                    <div className="flex-grow-1">
                        {' '}
                        {item.icon && <i className={`ph ${item.icon}`}></i>} {item.label}
                    </div>
                    {item.hasDropdown && (
                        <div>
                            <i
                                className={`ph ${
                                    openDropdown === item.page ? 'ph-caret-up' : 'ph-caret-right'
                                }`}
                                style={{ fontSize: '14px' }}
                            ></i>
                        </div>
                    )}
                </li>
                {item.hasDropdown && openDropdown === item.page && (
                    <ul className="ms-0">
                        {item.subItems.map((subItem: any) => (
                            <li
                                key={subItem.page}
                                className={`section-item ${
                                    activePage === subItem.page ? 'active' : ''
                                }`}
                                onClick={(e) => navigateDashboard(subItem.page, e.currentTarget)}
                            >
                                {subItem.label}
                            </li>
                        ))}
                    </ul>
                )}
            </React.Fragment>
        ));
    };
    const handleBackToDesigner = () => {
        navigate('/');
    };
    return (
        <Col
            id="horizontal-nav"
            className="cloud-sidebar d-flex flex-column no-scroll ps-4"
            md={2}
            style={{ height: `${iframeHeight}px` }}
        >
            <div>
                <ul className="sidebar-section mb-0 mt-0 ms-0 ps-0">
                    <li
                        className="section-item my-2 text-primary backButton"
                        style={{ fontSize: '14px' }}
                        onClick={handleBackToDesigner}
                    >
                        <i className="ph ph-caret-left"></i> Back to Designer
                    </li>
                </ul>
                {navigationConfig.map((section, index) => (
                    <ul className="sidebar-section" key={index}>
                        <li className="section-title">{section.title}</li>
                        {renderNavItems(section.items)}
                    </ul>
                ))}
            </div>
        </Col>
    );
};

export default Sidebar;
